<template>
<!-- eslint-disable -->
  <section
    v-if="checkAuth"
    class="feature_product_area latest_product_area alllistings"
    style="display: grid"
  >
    <div class="pushtop" style="height: 150px"></div>

    <!-- notifications-->
    <div v-if="saveNeed" class="ns-box ns-bar ns-effect-slidetop ns-type-notice ns-show">
      <div class="ns-box-inner">
        <span class="icon fa-solid fa-triangle-exclamation"></span>
        <p>
          You made some changes. Don't forget to save them!
          <a
            href="#"
            @click.prevent="handleSave"
            style="
              background-color: white;
              padding: 4px 8px;
              border-radius: 4px;
              border: 1px solid #ccc;
            "
          >
            {{ saveLoading ? 'Saving...' : 'Save Changes' }}
          </a>
        </p>
        <div v-if="saveError" class="error-message">{{ saveError }}</div>
      </div>
      <span class="ns-close"></span>
    </div>

    <div v-if="loading || isLoading">
      <LoadingSpinner />
      <p>Profile data is loading..</p>
    </div>

    <div v-else-if="userProfile" class="main_box">
      <ProfileSidebar 
        :activeTab="activeTab"
        :unreadCount="unreadCount"
        @change-tab="handleTabChange"
        @logout="handleLogout"
      />

      <div class="container" style="max-width: 1300px !important">
        <div class="profile-edit-wrap">
          <div class="profile-edit-page-header">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h2>Member Panel</h2>
            </div>
            <div class="breadcrumbs">
              <span class="header-user-name"
                >Hello {{ userProfile?.displayName }}
                <span>
                  <img
                    id="avatarImageShow"
                    :src="userProfile?.photoURL || '/images/avatar/1.jpg'"
                    class="respimg"
                    alt=""
                  />
                </span>
              </span>
            </div>
            <div></div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ProfileDashboard 
                v-if="activeTab === 'dashboard'"
                :activeListingsCount="activeListingsCount"
                :adLimit="adLimit"
                :totalListingViews="totalListingViews"
              />

              <ProfileAIConversations
                v-if="activeTab === 'aiConversations'"
              />

              <!-- eslint-disable-next-line vue/no-v-model-argument -->
              <ProfileSettings 
                v-if="activeTab === 'editProfile'"
                v-model:accountType="accountType"
                v-model:phoneNumber="phoneNumber"
                v-model:postalCode="postalCode"
                v-model:updateAddress="updateAddress"
                v-model:address="address"
                v-model:aboutMe="aboutMe"
                :userProfile="userProfile"
                :formatCreatedAt="formatCreatedAt"
                :isBreeder="isBreeder"
                :isServiceProvider="isServiceProvider"
                :photoUploadLoading="photoUploadLoading"
                :photoUploadError="photoUploadError"
                :postalCheckLoading="postalCheckLoading"
                :isValidPostalCode="isValidPostalCode"
                :postalCodeValidatedButNotSaved="postalCodeValidatedButNotSaved"
                :postalCodeSaved="postalCodeSaved"
                :postalError="postalError"
                :suggestedAddress="suggestedAddress"
                :saveLoading="saveLoading"
                :saveError="saveError"
                @photo-upload="handlePhotoUpload"
                @check-postal-code="checkPostalCode"
                @save-postal-code="savePostalCodeOnly"
                @fill-address="fillAddress"
                @save="handleSave"
              />

              <!-- eslint-disable-next-line vue/no-v-model-argument -->
              <CompanySettings 
                v-if="activeTab === 'editCompany'"
                :userProfile="userProfile"
                :userProfileReadyToPublish="userProfileReadyToPublish"
                :publishToggle="publishToggle"
                :publishLoading="publishLoading"
                :publishError="publishError"
                :publishSuccess="publishSuccess"
                :serviceAccountTypes="serviceAccountTypes"
                v-model:selectedServices="selectedServices"
                :coverUploadLoading="coverUploadLoading"
                :coverUploadError="coverUploadError"
                :coverImageUrl="coverImageUrl"
                :galleryLoading="galleryLoading"
                :errorMessage="errorMessage"
                :galleryImages="galleryImages"
                v-model:workingHours="workingHours"
                :saveLoading="saveLoading"
                @publish-toggle="handlePublishToggle"
                @publish="handlePublish"
                @cover-upload="handleCoverUpload"
                @gallery-upload="handleGalleryUpload"
                @remove-image="removeImage"
                @save="handleSave"
              />

              <ProfileListings 
                v-if="activeTab === 'myListing'"
                :userListings="userListings"
                :listingsLoading="listingsLoading"
                :listingType="listingType"
                @fetch-listings="fetchUserListings"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
  /* eslint-disable */
  import { ref, onMounted, computed, watch } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { getAuth, onAuthStateChanged, signOut, updateProfile } from 'firebase/auth';
  import LoadingSpinner from '@/components/LoadingSpinner.vue';
  import { useProfileSave } from '@/composables/useProfileSave';
  import { useUserStore } from '@/stores/userStore';
  import ProfileSidebar from '@/components/profile/ProfileSidebar.vue';
  import ProfileDashboard from '@/components/profile/ProfileDashboard.vue';
  import ProfileAIConversations from '@/components/profile/ProfileAIConversations.vue';
  import ProfileSettings from '@/components/profile/ProfileSettings.vue';
  import CompanySettings from '@/components/profile/CompanySettings.vue';
  import ProfileListings from '@/components/profile/ProfileListings.vue';

  import { storeToRefs } from 'pinia';
  import { useUnreadMessagesStore } from '@/stores/unreadMessagesStore';
  import { usePostalCodeManager } from '@/composables/usePostalCodeManager';

  import {
    collection,
    getDoc,
    query,
    orderBy,
    getDocs,
    doc,
    updateDoc,
    where,
  } from 'firebase/firestore';
  import { db } from '@/firebase';
  import { getUserListings, getTotalPetViews, updatePetListing } from '@/services/petService';
  import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
  import { storage } from '@/firebase';
  import { compressImage } from '@/utils/imageUtils';

  // Menu Panel değişkenleri
  const menuPanel = ref(true);
  const isMobile = ref(window.innerWidth < 920);

  const menuPanelClasses = computed(() => {
    return [
      menuPanel.value ? 'animate__backInLeft' : 'animate__backOutLeft',
      isMobile.value ? 'mobil-fix' : '',
    ];
  });

  const checkMobile = () => {
    isMobile.value = window.innerWidth < 920;
  };

  // saveNeed değişkeni false olarak başlat
  const saveNeed = ref(false);

  // Script değişkenleri - sonraki değişkenlerin altına ekleyin
  const userListings = ref([]);
  const listingsLoading = ref(false);
  const listingType = ref('active');
  const defaultImage =
    'https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fno-image.jpg?alt=media';

  // Edit modal için değişkenler
  const showEditConfirmModal = ref(false);
  const selectedListing = ref(null);
  const editLoading = ref(false);
  const countdownValue = ref(3);

  // Archive modal için değişkenler
  const showArchiveConfirmModal = ref(false);
  const archiveLoading = ref(false);

  // Restore modal için değişkenler
  const showRestoreConfirmModal = ref(false);
  const restoreLoading = ref(false);

  // Kullanıcı ilanlarını getirme fonksiyonu
  const activeListingsCount = ref(0);
  const totalListingViews = ref(0);

  const fetchTotalViews = async () => {
    if (!auth.currentUser) return;
    try {
      totalListingViews.value = await getTotalPetViews(auth.currentUser.uid);
    } catch (err) {
      console.error("Error fetching aggregate views", err);
    }
  };

  const fetchUserListings = async (type = 'active') => {
    if (!auth.currentUser) return;

    try {
      listingType.value = type;
      listingsLoading.value = true;
      userListings.value = [];
      const querySnapshot = await getUserListings(auth.currentUser.uid, type);
      userListings.value = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // Aktif ilan sayısını güncelle
      if (type === 'active') {
        activeListingsCount.value = userListings.value.length;
      }
    } catch (error) {
      console.error('Error fetching listings:', error);
    } finally {
      listingsLoading.value = false;
    }
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };
  // Description kısaltma
  const truncateDescription = (text) => {
    if (!text) return '';
    return text.length > 50 ? `${text.substring(0, 50)}...` : text;
  };

  // Tarih formatı
  const formatDate = (dateValue) => {
    if (!dateValue) return 'N/A';

    try {
      const date = dateValue.toDate ? dateValue.toDate() : new Date(dateValue);
      return new Intl.DateTimeFormat('en-GB', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      }).format(date);
    } catch (err) {
      console.error('Date formatting error:', err);
      return 'N/A';
    }
  };

  // Edit modal fonksiyonları
  const showEditModal = (listing) => {
    selectedListing.value = listing;
    showEditConfirmModal.value = true;
  };

  const cancelEditModal = () => {
    showEditConfirmModal.value = false;
    selectedListing.value = null;
  };

  const confirmEditListing = async () => {
    if (!selectedListing.value) return;

    try {
      editLoading.value = true;

      // İlanı draft olarak işaretle
      await updatePetListing(selectedListing.value.id, {
        draft: true,
        lastEditedAt: new Date(),
      });

      // Countdown başlat ve yönlendir
      countdownValue.value = 3;
      const countdownInterval = setInterval(() => {
        countdownValue.value -= 1;

        if (countdownValue.value <= 0) {
          clearInterval(countdownInterval);
          router.push('/add-listing');
        }
      }, 1000);
    } catch (error) {
      console.error('Error updating listing:', error);
      editLoading.value = false;
    }
  };

  // Archive modal fonksiyonları
  const showArchiveModal = (listing) => {
    selectedListing.value = listing;
    showArchiveConfirmModal.value = true;
  };

  const cancelArchiveModal = () => {
    showArchiveConfirmModal.value = false;
    selectedListing.value = null;
  };

  const confirmArchiveListing = async () => {
    if (!selectedListing.value) return;

    try {
      archiveLoading.value = true;

      // İlanı arşivle
      await updatePetListing(selectedListing.value.id, {
        status: 'archived',
        archivedAt: new Date(),
      });

      // Listeyi yenile
      await fetchUserListings('active');

      // Modal'ı kapat
      showArchiveConfirmModal.value = false;
      selectedListing.value = null;
    } catch (error) {
      console.error('Error archiving listing:', error);
    } finally {
      archiveLoading.value = false;
    }
  };

  // Restore modal fonksiyonları
  const showRestoreModal = (listing) => {
    selectedListing.value = listing;
    showRestoreConfirmModal.value = true;
  };

  const cancelRestoreModal = () => {
    showRestoreConfirmModal.value = false;
    selectedListing.value = null;
  };

  const confirmRestoreListing = async () => {
    if (!selectedListing.value) return;

    try {
      restoreLoading.value = true;

      // İlanı aktif et
      await updatePetListing(selectedListing.value.id, {
        status: 'active',
        restoredAt: new Date(),
      });

      // Listeyi yenile
      await fetchUserListings('archived');

      // Modal'ı kapat
      showRestoreConfirmModal.value = false;
      selectedListing.value = null;
    } catch (error) {
      console.error('Error restoring listing:', error);
    } finally {
      restoreLoading.value = false;
    }
  };

  // İlanları ilk yükleme
  onMounted(() => {
    // Mevcut onMounted içine ekleyin
    fetchUserListings('active');
    fetchTotalViews();
  });

  const photoUploadLoading = ref(false);
  const photoUploadError = ref(null);

  const membership_types = ref([]);

  const unreadStore = useUnreadMessagesStore();
  const { unreadCount, isLoading } = storeToRefs(unreadStore);

  const {
    postalCode,
    loading: postalCheckLoading,
    error: postalError,
    isValidPostalCode,
    suggestedAddress,
    validatePostCode,
    savePostalCodeData,
    loadPostalCodeData,
  } = usePostalCodeManager();

  // Posta kodu doğrulama fonksiyonunu güncelleyelim
  const checkPostalCode = async () => {
    const isValid = await validatePostCode(postalCode.value);
    if (isValid) {
      // Posta kodu doğrulandı ama henüz kaydedilmedi
      postalCodeValidatedButNotSaved.value = true;
    }
  };

  // Sadece posta kodu ve konum bilgilerini kaydet
  const postalCodeSaved = ref(false);

  // savePostalCodeOnly fonksiyonunu güncelleyelim
  const savePostalCodeOnly = async () => {
    const success = await savePostalCodeData();
    if (success) {
      // Başarılı kaydedildi mesajı göster
      postalCodeSaved.value = true;

      // Doğrulanmış ama kaydedilmemiş durumunu sıfırla
      postalCodeValidatedButNotSaved.value = false;

      // Kayıt yapıldığında saveNeed'i false yap
      saveNeed.value = false;

      // 3 saniye sonra mesajı kaldır
      setTimeout(() => {
        postalCodeSaved.value = false;
      }, 3000);
    }
  };
  // Doğrulanmış ama kaydedilmemiş posta kodu için bir state ekleyelim
  const postalCodeValidatedButNotSaved = ref(false);

  // Posta kodu değiştikçe, doğrulanmış ama kaydedilmemiş durumunu sıfırla
  watch(postalCode, () => {
    postalCodeValidatedButNotSaved.value = false;
  });

  const {
    saveProfile,
    publishProfile,
    unpublishProfile,
    error: saveError,
    loading: saveLoading,
  } = useProfileSave();
  const auth = getAuth();
  const user = ref(null);
  const phoneNumber = ref('');
  const address = ref('');
  const updateAddress = ref(false);
  const router = useRouter();
  const route = useRoute();
  
  const activeTab = ref(route.query.tab || 'dashboard');

  const handleTabChange = (tab) => {
    activeTab.value = tab;
  };

  const aboutMe = ref('');
  const serviceAccountTypes = ref([]);
  const selectedServices = ref([]);
  const accountType = ref('Personal');

  const galleryImages = ref([]);
  const galleryLoading = ref(false);
  const galleryInput = ref(null);
  const errorMessage = ref('');

  const workingHours = ref({
    monday: { open: '09:00', close: '17:00' },
    tuesday: { open: '09:00', close: '17:00' },
    wednesday: { open: '09:00', close: '17:00' },
    thursday: { open: '09:00', close: '17:00' },
    friday: { open: '09:00', close: '17:00' },
    saturday: { open: '10:00', close: '15:00' },
    sunday: { open: '', close: '' },
  });

  // Cover input referansını tanımlayalım
  const coverInput = ref(null);
  const coverImageUrl = ref('');
  const coverUploadLoading = ref(false);
  const coverUploadError = ref('');

  // Cover input trigger
  const handleCoverImagesInput = () => {
    if (!coverUploadLoading.value) {
      coverInput.value.click();
    }
  };

  // Cover yükleme fonksiyonu
  const handleCoverUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      coverUploadLoading.value = true;
      coverUploadError.value = '';

      // Kullanıcının account_number değerini al
      const accountNumber = userProfile.value?.account_number || Date.now().toString();

      // iOS tespiti
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      // İmajı optimize et
      const optimizedFile = await compressImage(file, 'cover', isIOS);

      // Önceki cover image varsa silmeye çalış
      if (userProfile.value?.account?.service_account?.coverImage) {
        try {
          // URL'den path çıkarma
          const decodedUrl = decodeURIComponent(
            userProfile.value.account.service_account.coverImage,
          );
          const pathStartIndex = decodedUrl.indexOf('/o/') + 3;
          const pathEndIndex = decodedUrl.indexOf('?', pathStartIndex);

          if (pathStartIndex > 3 && pathEndIndex > pathStartIndex) {
            // Firebase Storage path'ini elde et
            const storagePath = decodedUrl.substring(pathStartIndex, pathEndIndex);

            // Storage referansını oluştur
            const oldCoverRef = storageRef(storage, storagePath);

            // Firebase Storage'dan dosyayı sil
            await deleteObject(oldCoverRef);
            console.log('Old cover image deleted from storage');
          }
        } catch (storageError) {
          // Eski resim silme hatası (resim bulunamadı, erişim engeli vb.)
          console.error('Storage delete error for old cover:', storageError);
          // Bu hata işlemi durdurmayacak
        }
      }

      // Storage referansı oluştur
      const coverStoragePath = `public/profiles/${accountNumber}/cover/${optimizedFile.name}`;
      const coverRef = storageRef(storage, coverStoragePath);

      // Dosyayı Storage'a yükle
      await uploadBytes(coverRef, optimizedFile);

      // URL'i al
      const coverImageURL = await getDownloadURL(coverRef);

      // Firestore'daki service_account'ı güncelle
      const currentUser = getAuth().currentUser;
      if (currentUser) {
        const serviceAccountRef = doc(db, 'users', currentUser.uid, 'account', 'service_account');
        await updateDoc(serviceAccountRef, {
          coverImage: coverImageURL,
        });

        // Yerel state'i güncelle
        coverImageUrl.value = coverImageURL;

        // UserStore'u güncelle
        if (userProfile.value?.account?.service_account) {
          userProfile.value.account.service_account.coverImage = coverImageURL;
        }

        // Değişiklik olduğunu işaretle
        saveNeed.value = true;
      }

      // Input'u temizle
      event.target.value = null;
    } catch (error) {
      console.error('Error uploading cover image:', error);
      coverUploadError.value = 'Error uploading cover image. Please try again.';
    } finally {
      coverUploadLoading.value = false;
    }
  };

  // Profil fotoğrafı yükleme işlemi
  const handlePhotoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      photoUploadLoading.value = true;
      photoUploadError.value = null;

      // Kullanıcının account_number değerini al
      const accountNumber = userProfile.value?.account_number || Date.now().toString();

      // Dosyayı optimize et
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      const optimizedFile = await compressImage(file, 'profile', isIOS, 'image', 'profilePhoto');

      // Storage referansı oluştur
      const storageReference = storageRef(
        storage,
        `public/profiles/${accountNumber}/profilePhoto.${optimizedFile.name.split('.').pop()}`,
      );

      // Dosyayı Storage'a yükle
      await uploadBytes(storageReference, optimizedFile);

      // Yüklenen dosyanın URL'sini al
      const photoURL = await getDownloadURL(storageReference);

      // Kullanıcının firestore belgesini güncelle
      const currentUser = getAuth().currentUser;
      if (currentUser) {
        const userDocRef = doc(db, 'users', currentUser.uid);
        await updateDoc(userDocRef, { photoURL });

        // Kullanıcı profilini yeni URL ile güncelle
        userProfile.value.photoURL = photoURL;

        // Auth kullanıcı nesnesini de güncelle - DÜZELTILMIŞ KISIM
        await updateProfile(currentUser, { photoURL });

        console.log('Profile photo updated successfully');

        // Değişiklik olduğunu işaretle
        saveNeed.value = true;
      }
    } catch (error) {
      console.error('Error uploading profile photo:', error);
      photoUploadError.value = 'Profil fotoğrafı yüklenirken bir hata oluştu.';
    } finally {
      photoUploadLoading.value = false;
    }
  };

  const fetchMembershipTypes = async () => {
    try {
      // order alanına göre sıralanmış bir sorgu oluştur
      const membershipQuery = query(
        collection(db, 'membership_types'),
        orderBy('order', 'asc'), // order alanına göre artan sıralama
      );

      const querySnapshot = await getDocs(membershipQuery);
      const types = [];

      querySnapshot.forEach((doc) => {
        types.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      membership_types.value = types;
    } catch (err) {
      console.error('Error fetching membership types:', err);
    }
  };
  //ad limit
  const adLimit = computed(() => {
    return userProfile.value?.account?.properties?.ad_limit || 3;
  });

  const menuPanelTrigger = () => {
    menuPanel.value = !menuPanel.value;
  };

  const afterLeave = () => {
    // Animasyon bittikten sonra yapılacak işlemler
    //console.log('Animasyon tamamlandı');
  };


  const checkAuth = () => {
    if (!auth.currentUser) {
      router.push('/login');
      return false;
    }
    return true;
  };
  const goToChat = () => {
    router.push('/chat');
  };

  // Store'u başlat
  const userStore = useUserStore();
  // eslint-disable-next-line
  const { userProfile, loading } = storeToRefs(userStore);
  const fetchServiceAccountTypes = async () => {
    try {
      // Önce service_accounts dökümanını çek
      const serviceAccountsDoc = await getDoc(doc(db, 'account_types', 'service_accounts'));

      if (serviceAccountsDoc.exists()) {
        // Dökümanın içinden types dizisini al
        const typesArray = serviceAccountsDoc.data().types || [];

        // Her bir string için id ekleyerek objeye çevir
        const types = typesArray.map((type, index) => ({
          id: index.toString(), // Sayı yerine string ID kullan (Vue key için daha iyi)
          name: type, // String değeri name olarak kullan
        }));

        serviceAccountTypes.value = types;
        //console.log('Service account types loaded:', types);
      } else {
        console.log('Service accounts document not found');
        serviceAccountTypes.value = [];
      }
    } catch (err) {
      console.error('Error fetching service account types:', err);
      serviceAccountTypes.value = [];
    }
  };

  // Kullanıcı bilgilerini yükle
  onMounted(async () => {
    window.addEventListener('resize', checkMobile);

    await fetchMembershipTypes();
    await fetchServiceAccountTypes();
    await loadPostalCodeData();
    // Eğer kullanıcının zaten doğrulanmış bir posta kodu varsa
    if (isValidPostalCode.value) {
      postalCodeValidatedButNotSaved.value = false;
    }

    // Menü panelini 3 saniye sonra otomatik olarak aç
    setTimeout(() => {
      menuPanelTrigger();
    }, 3000);

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          // Store'dan profil bilgilerini al
          await userStore.fetchUserProfile(currentUser.uid);
          // Form alanlarını doldur
          if (userStore.userProfile) {
            user.value = userStore.userProfile;
            phoneNumber.value = userStore.userProfile.phoneNumber || '';
            address.value = userStore.userProfile.address || '';
            postalCode.value = userStore.userProfile.postalCode || '';
            aboutMe.value = userStore.userProfile.aboutMe || '';

            // Burayı ekleyin: Kullanıcının önceden seçilmiş servislerini yükle
            if (userStore.userProfile.account?.service_account?.types) {
              selectedServices.value = userStore.userProfile.account.service_account.types;
            }
            if (userStore.userProfile.account?.service_account?.working_hours) {
              // Her günün open ve close değerlerini kontrol et
              const savedHours = userStore.userProfile.account.service_account.working_hours;
              Object.keys(workingHours.value).forEach((day) => {
                if (savedHours[day]) {
                  // Eğer veritabanından gelen veri varsa kullan
                  workingHours.value[day].open =
                    savedHours[day].open || workingHours.value[day].open;
                  workingHours.value[day].close =
                    savedHours[day].close || workingHours.value[day].close;
                }
              });
            }
            // Cover image URL'sini yükle
            if (userStore.userProfile.account?.service_account?.coverImage) {
              coverImageUrl.value = userStore.userProfile.account.service_account.coverImage;
            }
            if (userStore.userProfile?.account?.service_account?.images) {
              galleryImages.value = userStore.userProfile.account.service_account.images;
            }
            // Hesap tipini ayarla
            if (userStore.userProfile.account?.service_account?.type) {
              accountType.value = userStore.userProfile.account.service_account.type;
            }
            if (userStore.userProfile) {
              publishToggle.value = !!userStore.userProfile.isServicePublished;
            }

            // Tüm form değişkenlerini izleyecek watch'ları başlatmadan önce profil yüklemesi tamamlandı
            setupFormWatchers();
          }
        } catch (err) {
          console.error('Error fetching user data:', err);
          user.value = null;
        }
      } else {
        user.value = null;
      }
    });

    return () => {
      window.removeEventListener('resize', checkMobile);
      unsubscribe();
    };
  });

  // Form değişikliklerini izleyecek fonksiyon
  const setupFormWatchers = () => {
    // Temel profil alanlarını izle
    watch(phoneNumber, () => {
      saveNeed.value = true;
    });
    watch(address, () => {
      saveNeed.value = true;
    });
    watch(postalCode, () => {
      saveNeed.value = true;
    });
    watch(aboutMe, () => {
      saveNeed.value = true;
    });
    watch(accountType, () => {
      saveNeed.value = true;
    });

    // Hizmet alanlarını izle
    watch(
      selectedServices,
      () => {
        saveNeed.value = true;
      },
      { deep: true },
    );

    // Çalışma saatlerini izle
    watch(
      workingHours,
      () => {
        saveNeed.value = true;
      },
      { deep: true },
    );

    // Şirket bilgilerini izle - Hesap tipine bağlı olarak
    if (userProfile.value?.account?.service_account) {
      const serviceAccount = userProfile.value.account.service_account;

      watch(
        () => serviceAccount.company_name,
        () => {
          saveNeed.value = true;
        },
      );
      watch(
        () => serviceAccount.company_description,
        () => {
          saveNeed.value = true;
        },
      );
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      userStore.clearUserData();
    } catch (error) {
      console.error('Çıkış yaparken hata oluştu:', error);
    }
  };

  // Profil resmi URL'sini düzelt
  const getProfileImage = (photoURL) => {
    if (photoURL && photoURL.includes('=s96-c')) {
      return photoURL.replace('=s96-c', '=s400-c');
    }
    return (
      photoURL ||
      'https://firebasestorage.googleapis.com/v0/b/petqueen-v3.firebasestorage.app/o/public%2Fassets%2Fdefault-avatar.png?alt=media'
    ); // Varsayılan bir resim URL'si ekleyin
  };

  // Galeri input trigger
  const handleImagesInput = () => {
    if (!galleryLoading.value && galleryImages.value.length < 20) {
      galleryInput.value.click();
    }
  };

  // Galeri yükleme fonksiyonu
  const handleGalleryUpload = async (event) => {
    const files = event.target.files;
    if (!files || !files.length) return;

    // 20 resim kontrolü
    const totalImages = galleryImages.value.length + files.length;
    if (totalImages > 20) {
      errorMessage.value = `You can only upload up to 20 images. You have ${galleryImages.value.length}, you can add ${20 - galleryImages.value.length} more.`;
      setTimeout(() => {
        errorMessage.value = '';
      }, 5000);
      return;
    }

    try {
      galleryLoading.value = true;
      errorMessage.value = '';

      // Kullanıcının account_number değerini al
      const accountNumber = userProfile.value?.account_number || Date.now().toString();

      // iOS tespiti
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      // Tüm dosyaları işleyelim
      const uploadPromises = Array.from(files).map(async (file) => {
        // İmajı optimize et (rastgele isim için fileName parametresini boş bırak)
        const optimizedFile = await compressImage(file, 'gallery', isIOS, 'image');

        // Storage referansı oluştur
        const imageStoragePath = `public/profiles/${accountNumber}/gallery/${optimizedFile.name}`;
        const imageRef = storageRef(storage, imageStoragePath);

        // Dosyayı Storage'a yükle
        await uploadBytes(imageRef, optimizedFile);

        // URL'i al
        const imageUrl = await getDownloadURL(imageRef);

        // Firestore'a kaydedilecek nesneyi hazırla (URL ve storage path'i saklayalım)
        return {
          url: imageUrl,
          path: imageStoragePath,
          uploadedAt: new Date(),
        };
      });

      // Tüm yüklemelerin tamamlanmasını bekle
      const uploadedImages = await Promise.all(uploadPromises);

      // Firestore'a kaydedilecek array'i hazırla
      const currentImages = userProfile.value?.account?.service_account?.images || [];
      const updatedImages = [...currentImages, ...uploadedImages.map((img) => img.url)];
      // Firestore'daki service_account'ı güncelle
      const currentUser = getAuth().currentUser;
      if (currentUser) {
        const serviceAccountRef = doc(db, 'users', currentUser.uid, 'account', 'service_account');
        await updateDoc(serviceAccountRef, {
          images: updatedImages,
        });

        // Yerel state'i güncelle
        galleryImages.value = updatedImages;

        // UserStore'u güncelle
        if (userProfile.value?.account?.service_account) {
          userProfile.value.account.service_account.images = updatedImages;
        }
        // Eğer yayınlanmış profil varsa, services koleksiyonundaki dokümanda da gallery'i güncelle
        if (userProfile.value?.isServicePublished && userProfile.value?.publishedService) {
          try {
            const serviceRef = doc(db, 'services', userProfile.value.publishedService);
            await updateDoc(serviceRef, {
              galleryImages: updatedImages,
              updatedAt: new Date(),
            });
            console.log('Published service gallery images updated successfully');
          } catch (updateErr) {
            console.error('Error updating published service gallery images:', updateErr);
          }
        }

        // Değişiklik olduğunu işaretle
        saveNeed.value = true;
      }

      // Input'u temizle
      event.target.value = null;
    } catch (error) {
      console.error('Error uploading gallery images:', error);
      errorMessage.value = 'Error uploading images. Please try again.';
    } finally {
      galleryLoading.value = false;
    }
  };

  // Resim silme fonksiyonu
  const removeImage = async (index) => {
    if (galleryLoading.value) return;

    try {
      galleryLoading.value = true;

      // Silinecek resmin URL'ini al
      const imageUrl = galleryImages.value[index];

      // URL'i decode edip path kısmını çıkaralım
      const decodedUrl = decodeURIComponent(imageUrl);
      const pathStartIndex = decodedUrl.indexOf('/o/') + 3;
      const pathEndIndex = decodedUrl.indexOf('?', pathStartIndex);

      if (pathStartIndex > 3 && pathEndIndex > pathStartIndex) {
        // Firebase Storage path'ini elde et
        const storagePath = decodedUrl.substring(pathStartIndex, pathEndIndex);

        // Storage referansını oluştur
        const imageRef = storageRef(storage, storagePath);

        // Firebase Storage'dan dosyayı sil
        try {
          await deleteObject(imageRef);
          console.log('Image deleted from storage:', storagePath);
        } catch (storageError) {
          // Storage'dan silme hatası (resim bulunamadı, erişim engeli vb.)
          console.error('Storage delete error:', storageError);
          // Bu hata işlemi durdurmayacak, Firestore güncellemesine devam edeceğiz
        }
      }

      // Mevcut resimleri kopyala ve ilgili resmi çıkar
      const updatedImages = [...galleryImages.value];
      updatedImages.splice(index, 1);

      // Firestore'u güncelle
      const currentUser = getAuth().currentUser;
      if (currentUser) {
        const serviceAccountRef = doc(db, 'users', currentUser.uid, 'account', 'service_account');
        await updateDoc(serviceAccountRef, {
          images: updatedImages,
        });

        // Yerel state'i güncelle
        galleryImages.value = updatedImages;

        // UserStore'u güncelle
        if (userProfile.value?.account?.service_account) {
          userProfile.value.account.service_account.images = updatedImages;
        }
        // Eğer yayınlanmış profil varsa, services koleksiyonundaki dokümanda da gallery'i güncelle
        if (userProfile.value?.isServicePublished && userProfile.value?.publishedService) {
          try {
            const serviceRef = doc(db, 'services', userProfile.value.publishedService);
            await updateDoc(serviceRef, {
              galleryImages: updatedImages,
              updatedAt: new Date(),
            });
            console.log('Published service gallery images updated after removal');
          } catch (updateErr) {
            console.error(
              'Error updating published service after gallery image removal:',
              updateErr,
            );
          }
        }

        // Değişiklik olduğunu işaretle
        saveNeed.value = true;
      }
    } catch (error) {
      console.error('Error removing image:', error);
      errorMessage.value = 'Error removing image. Please try again.';
    } finally {
      galleryLoading.value = false;
    }
  };

  // Kullanıcı bilgilerini kaydet
  const handleSave = async () => {
    try {
      const userData = await saveProfile({
        phoneNumber: phoneNumber.value,
        address: address.value,
        aboutMe: aboutMe.value,
        serviceAccount: {
          types: selectedServices.value,
          working_hours: workingHours.value,
          company_name: userProfile.value.account?.service_account?.company_name || '',
          company_description:
            userProfile.value.account?.service_account?.company_description || '',
          type: accountType.value,
        },
      });

      // Handle postal code deletion or un-saved validation
      if (postalCode.value === '' || postalCodeValidatedButNotSaved.value) {
        await savePostalCodeOnly();
      }

      user.value = userData;

      // Eğer kullanıcının yayınlanmış bir ilanı varsa, güncelle
      if (userProfile.value?.isServicePublished && userProfile.value?.publishedService) {
        try {
          const currentUser = getAuth().currentUser;
          if (!currentUser) return;

          // Yayınlanmış ilan için güncel veriler
          const updatedServiceData = {
            updatedAt: new Date(),
            displayName: userData.displayName || '',
            photoURL: userData.photoURL || '',
            address: userData.address || '',
            aboutMe: userData.aboutMe || '',
            phoneNumber: userData.phoneNumber || '',

            // Service account bilgileri
            companyName: userProfile.value.account?.service_account?.company_name || '',
            companyDescription:
              userProfile.value.account?.service_account?.company_description || '',
            coverImage: userProfile.value.account?.service_account?.coverImage || '',
            galleryImages: userProfile.value.account?.service_account?.images || [],
            workingHours: userProfile.value.account?.service_account?.working_hours || {},
            services: userProfile.value.account?.service_account?.types || [],
            type: userProfile.value.account?.service_account?.type || 'Personal',
          };

          // Services koleksiyonundaki ilanı güncelle
          const serviceRef = doc(db, 'services', userProfile.value.publishedService);
          await updateDoc(serviceRef, updatedServiceData);

          console.log('Published service updated successfully');
        } catch (updateErr) {
          console.error('Error updating published service:', updateErr);
        }
      }

      // Kaydetme işlemi başarılı olduğunda saveNeed'i false yap
      saveNeed.value = false;
    } catch (err) {
      console.error('Profile update error :', err);
    }
  };

  // Adres alanını otomatik doldur
  const fillAddress = () => {
    if (updateAddress.value && suggestedAddress.value) {
      address.value = suggestedAddress.value;

      // Diğer alanları otomatik doldur
    }
  };

  const formatCreatedAt = computed(() => {
    if (!userProfile.value?.createdAt) return 'N/A';

    const date = userProfile.value.createdAt.toDate();
    return new Intl.DateTimeFormat('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(date);
  });

  const isBreeder = computed(() => {
    return userProfile.value?.account?.pet_account?.type !== 'Member';
  });

  const isServiceProvider = computed(() => {
    return userProfile.value?.account?.service_account?.type !== 'Member';
  });

  // Mevcut değişkenler...
  const publishToggle = ref(false);
  const publishLoading = ref(false);
  const publishError = ref('');
  const publishSuccess = ref(false);

  // Profil yayınlama işlemini işleyecek fonksiyon
  const handlePublish = async () => {
    if (!publishToggle.value || userProfile.value.isServicePublished) return;

    publishLoading.value = true;
    publishError.value = '';
    publishSuccess.value = false;

    try {
      // Profil yayınlama fonksiyonunu çağır
      const result = await publishProfile();

      if (result.success) {
        publishSuccess.value = true;

        // Kullanıcı profilini güncelle - servis yayınlandı olarak işaretle
        if (userProfile.value) {
          userProfile.value.isServicePublished = true;
          userProfile.value.publishedService = result.serviceId;
          userProfile.value.publishedAt = new Date();
        }

        // Değişiklik olduğu için saveNeed'i true yap
        saveNeed.value = true;

        // Yayınlama başarılı mesajını göster
        setTimeout(() => {
          // Toggle'ı kapat ama watch'ı tetikleme
          //const oldValue = publishToggle.value;
          publishToggle.value = false;
          // Bu iki satır, watch'ın unpublish işlemini tetiklememesi için
          // kullanıcı publish ettikten sonra yapılıyor
        }, 3000);
      } else {
        publishError.value = result.error || 'An error occurred while publishing your profile';
      }
    } catch (err) {
      console.error('Error publishing profile:', err);
      publishError.value = err.message || 'An error occurred while publishing your profile';
    } finally {
      publishLoading.value = false;
    }
  };

  const handlePublishToggle = async (event) => {
    const newState = event.target.checked;
    publishToggle.value = newState;

    // Eğer uncheck olmuşsa ve profil yayınlanmış durumdaysa
    if (!newState && userProfile.value.isServicePublished) {
      publishLoading.value = true;
      publishError.value = '';
      publishSuccess.value = false;

      try {
        // Profil unpublish fonksiyonunu çağır
        const result = await unpublishProfile();

        if (result.success) {
          // Kullanıcı profilini güncelle
          if (userProfile.value) {
            userProfile.value.isServicePublished = false;
          }

          // Değişiklik olduğu için saveNeed'i true yap
          saveNeed.value = true;

          publishSuccess.value = true;
          setTimeout(() => {
            publishSuccess.value = false;
          }, 3000);
        } else {
          publishError.value = result.error || 'An error occurred while unpublishing your profile';
        }
      } catch (err) {
        console.error('Error unpublishing profile:', err);
        publishError.value = err.message || 'An error occurred while unpublishing your profile';
      } finally {
        publishLoading.value = false;
      }
    }
    // Eğer check edilmişse ve publish başlat seçeneği gösterilmeli
    else if (newState && !userProfile.value.isServicePublished) {
      // Bu durumda bir şey yapmaya gerek yok, zaten publish butonu gösterilecek
      // ve handlePublish fonksiyonu ile işlem yapılacak
    }
  };

  // Profil yayınlanmaya hazır mı kontrolünü yapan computed property
  const userProfileReadyToPublish = computed(() => {
    // Gerekli alanları kontrol et
    if (!userProfile.value) return false;

    const serviceAccount = userProfile.value.account?.service_account;

    // Temel profil bilgilerini kontrol et
    const hasBasicInfo =
      userProfile.value.displayName &&
      userProfile.value.phoneNumber &&
      userProfile.value.postalCode;

    // Servis bilgilerini kontrol et
    const hasServiceInfo =
      serviceAccount &&
      serviceAccount.type &&
      serviceAccount.coverImage &&
      serviceAccount.company_description &&
      serviceAccount.working_hours &&
      serviceAccount.types &&
      serviceAccount.types.length > 0 &&
      serviceAccount.images &&
      serviceAccount.images.length > 0;

    return hasBasicInfo && hasServiceInfo;
  });
</script>


<style src="@/assets/css/profile.css"></style>
